"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPureManualAccounts = exports.getTrackingAggregator = exports.getErrorCount = exports.isInstitutionLoginAmbiguous = exports.getInstitutionLoginsByName = exports.wasUserActionCancelled = exports.isUserActionPending = exports.hasUserActionBeenQueued = exports.getCredentialsForRefreshingLogins = exports.getCredentialBlobsForRefreshingLogins = exports.getIdsRefreshingWithCancelledUserActions = exports.getIdsRefreshingWithUserActionsPending = exports.getIsRefreshing = exports.getIsRefreshingSome = exports.getIdsRefreshing = exports.getIsRefreshingAll = exports.getInstitutionLoginForId = exports.getIsLoading = exports.getLastSyncDate = exports.getLoadPending = exports.getInstitutionLoginsById = exports.getInstitutionLoginsStore = void 0;
const reselect_1 = require("reselect");
const immutable_1 = require("immutable");
const accounts_1 = require("companion-app-components/flux/accounts");
const utils_1 = require("data/institutionLogins/utils");
const reducer_1 = require("./reducer");
const getInstitutionLoginsStore = (state) => state[reducer_1.REDUCER_KEY];
exports.getInstitutionLoginsStore = getInstitutionLoginsStore;
const getInstitutionLoginsById = (state) => (0, exports.getInstitutionLoginsStore)(state).resourcesById;
exports.getInstitutionLoginsById = getInstitutionLoginsById;
const getLoadPending = (state) => (0, exports.getInstitutionLoginsStore)(state).loadPending;
exports.getLoadPending = getLoadPending;
const getLastSyncDate = (state) => (0, exports.getInstitutionLoginsStore)(state).lastSyncDate;
exports.getLastSyncDate = getLastSyncDate;
const getIsLoading = (state) => (0, exports.getInstitutionLoginsStore)(state).isLoading;
exports.getIsLoading = getIsLoading;
const getInstitutionLoginForId = (state, id) => (0, exports.getInstitutionLoginsById)(state).get(id);
exports.getInstitutionLoginForId = getInstitutionLoginForId;
const getIsRefreshingAll = (state) => (0, exports.getInstitutionLoginsStore)(state).isRefreshingAll;
exports.getIsRefreshingAll = getIsRefreshingAll;
const getIdsRefreshing = (state) => (0, exports.getInstitutionLoginsStore)(state).idsRefreshing;
exports.getIdsRefreshing = getIdsRefreshing;
const getIsRefreshingSome = (state) => (0, exports.getIdsRefreshing)(state).size > 0;
exports.getIsRefreshingSome = getIsRefreshingSome;
const getIsRefreshing = (state) => (0, exports.getIsRefreshingAll)(state) || (0, exports.getIdsRefreshing)(state).size > 0;
exports.getIsRefreshing = getIsRefreshing;
const getIdsRefreshingWithUserActionsPending = (state) => (0, exports.getInstitutionLoginsStore)(state).idsRefreshingWithUserActionsPending;
exports.getIdsRefreshingWithUserActionsPending = getIdsRefreshingWithUserActionsPending;
const getIdsRefreshingWithCancelledUserActions = (state) => (0, exports.getInstitutionLoginsStore)(state).idsRefreshingWithCancelledUserActions;
exports.getIdsRefreshingWithCancelledUserActions = getIdsRefreshingWithCancelledUserActions;
const getCredentialBlobsForRefreshingLogins = (state) => (0, exports.getInstitutionLoginsStore)(state).credentialBlobsForRefreshingLogins;
exports.getCredentialBlobsForRefreshingLogins = getCredentialBlobsForRefreshingLogins;
const getCredentialsForRefreshingLogins = (state) => (0, exports.getInstitutionLoginsStore)(state).credentialsForRefreshingLogins;
exports.getCredentialsForRefreshingLogins = getCredentialsForRefreshingLogins;
const hasUserActionBeenQueued = (state, institutionLoginId) => ((0, exports.getIdsRefreshingWithUserActionsPending)(state).has(institutionLoginId) ||
    (0, exports.getIdsRefreshingWithCancelledUserActions)(state).has(institutionLoginId));
exports.hasUserActionBeenQueued = hasUserActionBeenQueued;
exports.isUserActionPending = (0, reselect_1.createSelector)(exports.getIdsRefreshingWithUserActionsPending, (_, props) => props ? props.institutionLoginIdId : null, (idsRefreshingWithUserActionsPending, institutionLoginId) => (institutionLoginId == null ?
    idsRefreshingWithUserActionsPending.size > 0 :
    idsRefreshingWithUserActionsPending.has(institutionLoginId)));
const wasUserActionCancelled = (state, institutionLoginId) => (0, exports.getIdsRefreshingWithCancelledUserActions)(state).has(institutionLoginId);
exports.wasUserActionCancelled = wasUserActionCancelled;
exports.getInstitutionLoginsByName = (0, reselect_1.createSelector)(exports.getInstitutionLoginsById, (institutionLoginsById) => !institutionLoginsById ? null :
    institutionLoginsById.sort((objInstitution1, objInstitution2) => {
        if (objInstitution1.name) {
            return (objInstitution1.name.localeCompare(objInstitution2.name, undefined, { numeric: true, sensitivity: 'base' }));
        }
        return 0;
    }));
exports.isInstitutionLoginAmbiguous = (0, reselect_1.createSelector)(exports.getInstitutionLoginsById, (_, props) => props.institutionLoginId, (institutionLoginsById, institutionLoginId) => {
    if (!institutionLoginId) {
        return undefined;
    }
    const institutionLogin = institutionLoginsById.get(institutionLoginId);
    const ambiguousInstitutionLogin = institutionLoginsById.find((iInstitutionLogin) => iInstitutionLogin.institutionId === institutionLogin.institutionId && iInstitutionLogin.id !== institutionLogin.id);
    return ambiguousInstitutionLogin !== undefined;
});
exports.getErrorCount = (0, reselect_1.createSelector)((state, accountsByInstitutionLoginId) => accountsByInstitutionLoginId, exports.getInstitutionLoginsByName, (accountsByInstitutionLoginId, institutionLoginsByName) => {
    let count = 0;
    let loginsErrorCount = 0;
    let accountsErrorCount = 0;
    let institutionLogin = {};
    institutionLoginsByName === null || institutionLoginsByName === void 0 ? void 0 : institutionLoginsByName.forEach((login) => {
        var _a;
        const accounts = accountsByInstitutionLoginId === null || accountsByInstitutionLoginId === void 0 ? void 0 : accountsByInstitutionLoginId.get(login.id);
        if (!accounts) {
            // if we don't have any accounts for login, then ignore login
            return;
        }
        const loginAggStatus = (_a = login.aggregators) === null || _a === void 0 ? void 0 : _a.get(0).aggStatus;
        if ((0, utils_1.isErrorType)(loginAggStatus)) {
            loginsErrorCount += 1;
            institutionLogin = login;
        }
        else {
            accounts === null || accounts === void 0 ? void 0 : accounts.forEach((account) => {
                var _a;
                const accountAggStatus = (_a = account.aggregators) === null || _a === void 0 ? void 0 : _a.get(0).aggStatus;
                if (accountAggStatus && (0, utils_1.isErrorType)(accountAggStatus)) {
                    accountsErrorCount += 1;
                    institutionLogin = login;
                }
            });
        }
        count = loginsErrorCount + accountsErrorCount;
    });
    return { count, institutionLogin };
});
exports.getTrackingAggregator = (0, reselect_1.createSelector)(exports.getInstitutionLoginForId, (institutionLogin) => {
    if (institutionLogin.channel) {
        if (institutionLogin.channel.startsWith('FDS')) {
            return 'INTUIT_FDS';
        }
        if (institutionLogin.channel.startsWith('FDP')) {
            return 'INTUIT_FDP';
        }
        if (institutionLogin.channel.startsWith('FINICITY')) {
            return 'FINICITY';
        }
        if (institutionLogin.channel.startsWith('PLAID')) {
            return 'PLAID';
        }
    }
    return 'UNKNOWN';
});
// This selector returns all "pure" manual accounts. A pure manual is an account that either does not belong to an
// institution-login or belongs to an "unconnected" institution-login. While QCS supports accounts being grouped into
// unconnected-logins, it is only used by Windows to group all manual accounts into a single unconnected
// institution-login (this isn't required but is a holdover from Windows syncing to Mint).
//
exports.getPureManualAccounts = (0, reselect_1.createSelector)(exports.getInstitutionLoginsById, accounts_1.accountsSelectors.getAccountsByInstitutionLoginId, (institutionLoginsById, accountsByInstitutionId) => {
    const pureManualAccounts = accountsByInstitutionId.reduce((list, accounts, institutionLoginId) => {
        const institutionLogin = institutionLoginsById.get(institutionLoginId);
        if (Number(institutionLoginId) === 0 || (institutionLogin && Number(institutionLogin.institutionId) === 0)) {
            accounts.forEach((account) => list.push(account));
        }
        return list;
    }, []);
    return (0, immutable_1.List)(pureManualAccounts);
});
